import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import BiLink from '../../biLogger/Components/BiLink';
import BiButton from '../../biLogger/Components/BiButton';
import ArtStageArrowL from '../../Icons/ArtStageArrowL';
import s from './BackToButton.scss';
/** DS B4: Anchor of the form '< Back to <somewhere>' */
export var BackToButtonB4 = function (_a) {
    var href = _a.href, onClick = _a.onClick, className = _a.className, children = _a.children, biData = _a.biData;
    var t = useTranslation().t;
    var Clickable = href ? BiLink : BiButton;
    return (React.createElement(Clickable, { className: classnames(s['root'], className), href: href, onClick: onClick, biData: biData },
        React.createElement(ArtStageArrowL, { customSizable: true, className: s['arrow'] }),
        children ? (React.createElement(React.Fragment, null,
            t('button.backToButton.backTo'),
            ' ',
            React.createElement("b", { className: s['contents'] }, children))) : (t('button.backToButton.back'))));
};
BackToButtonB4.displayName = 'BackToButtonB4';
export default BackToButtonB4;
//# sourceMappingURL=BackToButton.js.map